import React, { lazy, Suspense } from "react";

export { default as ListParadan } from "./Paradan_Agent/ListParadan";
export { default as Paradan } from "./Paradan_Agent/Paradan";
export { default as Print_ViewParadan } from "./Paradan_Agent/Print_ViewParadan";

export { default as Asaysh_Form } from "./Scurety_Agent/Asaysh_Form";
export { default as PrintAsaysh } from "./Scurety_Agent/PrintAsaysh";
export { default as ScurityList } from "./Scurety_Agent/ScurityList";

export { default as ListTakeMoney } from "./TakeMoney_Agent/ListTakeMoney";
export { default as Print_ViewTakemoney } from "./TakeMoney_Agent/Print_ViewTakemoney";
export { default as TakeMoney } from "./TakeMoney_Agent/TakeMoney";
export { default as PrintBills } from "./TakeMoney_Agent/PrintBills";
export { default as PrintRePayments } from "./Paradan_Agent/PrintRePayments";

const LazyPrintViewScurety = lazy(() =>
  import("./Scurety_Agent/PrintViewScurety")
);

const LazyListMasrufat = lazy(() => import("./Masrufat_Agent/ListMasrufat"));
const LazyPrintMasrufat = lazy(() => import("./Masrufat_Agent/PrintMasrufat"));

const LazyListWriteForm = lazy(() => import("./Writer_Agent/ListWriteForm"));
const LazyPrintWriteForm = lazy(() => import("./Writer_Agent/PrintWriteForm"));

const LazyKryar_Form = lazy(() => import("./Scurety_Agent/Kryar_Form"));
const LazyPrintKryar = lazy(() => import("./Scurety_Agent/PrintKryar"));
const LazyPrintViewKryar = lazy(() => import("./Scurety_Agent/PrintViewKryar"));
const LazyListKryar = lazy(() => import("./Scurety_Agent/ListKryar"));

export const PrintViewScurety = () => (
  <Suspense fallback="loading...">
    <LazyPrintViewScurety />
  </Suspense>
);

export const ListMasrufat = () => (
  <Suspense fallback="loading...">
    <LazyListMasrufat />
  </Suspense>
);
export const PrintMasrufat = () => (
  <Suspense fallback="loading...">
    <LazyPrintMasrufat />
  </Suspense>
);

export const ListWriteForm = () => (
  <Suspense fallback="loading...">
    <LazyListWriteForm />
  </Suspense>
);
export const PrintWriteForm = () => (
  <Suspense fallback="loading...">
    <LazyPrintWriteForm />
  </Suspense>
);

export const Kryar_Form = () => (
  <Suspense fallback="loading...">
    <LazyKryar_Form />
  </Suspense>
);
export const PrintKryar = () => (
  <Suspense fallback="loading...">
    <LazyPrintKryar />
  </Suspense>
);
export const PrintViewKryar = () => (
  <Suspense fallback="loading...">
    <LazyPrintViewKryar />
  </Suspense>
);
export const ListKryar = () => (
  <Suspense fallback="loading...">
    <LazyListKryar />
  </Suspense>
);
